module.exports = __webpack_public_path__ + "static/media/land_blauw.68b7ff51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/land_blauw.svg
// module id = 606
// module chunks = 0